module.exports = __webpack_public_path__ + "img/login-right.969d21fb.png";